import { alpha, ButtonBase, Stack, Typography, useTheme } from "@mui/material";
import type { FC, ReactNode } from "react";

type Props = {
	ring: ReactNode;
	value: string;
	label: string;
	onClick: () => void;
};

export const DashboardGoalsCardItem: FC<Props> = ({
	ring,
	value,
	label,
	onClick,
}) => {
	const { palette, spacingTokens, dashboard, radii } = useTheme();

	return (
		<ButtonBase
			onClick={onClick}
			sx={{
				width: dashboard.goalsCard.columnWidth,
				flexShrink: 0,
				borderRadius: radii.lg,
				color: palette.darkmodeText.white,
			}}
		>
			<Stack alignItems="center" gap={spacingTokens.xs} width="100%">
				{ring}
				<Stack alignItems="center" width="100%">
					<Typography
						variant="displaySm"
						color={palette.darkmodeText.white}
						tabular
					>
						{value}
					</Typography>
					<Typography
						variant="caption"
						color={alpha(palette.darkmodeText.white, 0.8)}
						maxWidth="100%"
						noWrap
					>
						{label}
					</Typography>
				</Stack>
			</Stack>
		</ButtonBase>
	);
};
